import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';
import { UserProfileDialogComponent } from './user-profile-dialog.component';

@NgModule({
  declarations: [UserProfileDialogComponent],
  imports: [CommonModule, FormsModule, ButtonModule, TranslatePipe],
  exports: [UserProfileDialogComponent],
})
export class UserProfileModule {}
